const snack = {
	open: false,
	message: '',
	type: 'error'
};

export default snack;
